module.exports = __webpack_public_path__ + "img/aluminum-window.af022601.jpg";